import { Outlet, useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { HankoDialog } from "../components/HankoDialog";
import { ChatwootWidget } from "../components/ChatwootWidget";
import { HankoContext } from "../components/HankoElements/HankoProvider";

export const UserWrapper = () => {
  const [dialogOpen, setDialogOpen] = useState(false)
  const navigate = useNavigate()
  const { hanko } = useContext(HankoContext)

  const navigateToLogin = () => {
    navigate("/login", { state: document.location.pathname + document.location.search })
  }

  useEffect(() => {
    hanko?.onUserLoggedOut(userLoggedOut)
    hanko?.onSessionCreated(userLoggedIn)
    hanko?.onSessionExpired(sessionExpired)
  }, [hanko]);

  const userLoggedOut = () => {
    navigate("/login")
  }

  const userLoggedIn = () => {
    if (dialogOpen) {
      setDialogOpen(false)
      return
    }
  }

  const sessionExpired = () => {
    setDialogOpen(true)
  }

  return <>
    <ChatwootWidget />
    <HankoDialog closeable={false} open={dialogOpen} onClose={() => {
    }}>
      <Box maxWidth="500px" sx={{ display: "flex", gap: "20px", flexDirection: 'column' }}>
        <Typography variant="h4">Session expired</Typography>
        <Typography variant="body1">Your session is expired. Please sign in again.</Typography>
        <Button variant="contained" fullWidth onClick={navigateToLogin}>Sign in</Button>
      </Box>
    </HankoDialog>
    <Outlet />
  </>
}